/* eslint-disable no-unused-vars */
import clsx from 'clsx'
import dayjs from 'dayjs'
import React from 'react'
import { EVENT_TYPES, MINUTES_PER_HOUR, TIME_FORMAT } from '../../../constants'
import { getIconforEvent } from '../../../icons'
import { IEvent } from '../../../types'
import {
  convertType,
  convertTypeDisable,
  customDateFormat,
  isDisplayIcon
} from '../../../utils'
import styles from '../SAPPCalendar.module.css'
import CustomTooltip from '../common/CustomTooltip'

interface IWeeklyEventProps {
  event: IEvent
  onOpenDetail?: (date: Date, events: IEvent[]) => void
  onEventDetail?: (event: IEvent) => void
}

const calculateBoxSize = (startTime: Date, endTime: Date) => {
  const minutes = dayjs(startTime).minute()
  const diffMinutes = dayjs(endTime).diff(startTime, 'hour', true)
  return {
    width: diffMinutes || 1,
    left: Math.floor((minutes / MINUTES_PER_HOUR) * 100)
  }
}

const LMSWeeklyEvent = ({
  event,
  onOpenDetail,
  onEventDetail
}: IWeeklyEventProps) => {
  const formattedDate =
    customDateFormat(event.startDate, TIME_FORMAT) +
    ' - ' +
    customDateFormat(event.endDate, TIME_FORMAT)

  const { width, left } = calculateBoxSize(event.startDate, event.endDate)
  const iconList = getIconforEvent(event, event.isActive)
  const typeClass = event.isActive
    ? convertType[event.type] || 'default'
    : convertTypeDisable[event.type] || 'default'
  const className = event?.isOverDue ? `event-error` : `event-${typeClass}`

  return (
    <div
      className={styles[className]}
      onClick={() => {
        onOpenDetail && onOpenDetail(dayjs(event.startDate).toDate(), [event])
        onEventDetail && onEventDetail(event)
      }}
      style={{
        top: `0%`,
        height: `100%`,
        width: width * 100 + '%',
        left: left + '%',
        zIndex: event.type === EVENT_TYPES.BUSY ? 2 : 1
      }}
    >
      <div className={clsx(styles['weekly-event'])}>
        <div className={clsx(styles['weekly-event--collapse'])}>
          <div className={styles['weekly-event__title']}>
            {isDisplayIcon(event) && (
              <div className={styles['weekly-event__title_icon']}>
                {iconList}
              </div>
            )}
            <CustomTooltip title={event.title}>
              <div className={styles['truncate-text']}>{event.title}</div>
            </CustomTooltip>
          </div>
        </div>
        <div className={styles['weekly-event__date']}>
          <CustomTooltip title={formattedDate}>{formattedDate}</CustomTooltip>
        </div>
      </div>
    </div>
  )
}
export default LMSWeeklyEvent
